import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LandingService } from '../landing.service';
import { environment } from 'environments/environment';
import { VCard } from 'ngx-vcard';
import { BasicPropertyParameters } from 'ngx-vcard/lib/types/parameter/BasicPropertyParameters.type';
import { Address } from 'ngx-vcard/lib/types/vCard';
import { NgxGalleryComponent, NgxGalleryOptions } from '@kolkov/ngx-gallery';
import { NgxGalleryImage } from '@kolkov/ngx-gallery';
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-digital-card',
  templateUrl: './digital-card.component.html',
  styleUrls: ['./digital-card.component.scss']
})
export class DigitalCardComponent implements OnInit {
  @ViewChild('gallery') gallery: NgxGalleryComponent;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  @ViewChild('galleryAgent') galleryAgent: NgxGalleryComponent;
  galleryImagesAgent: NgxGalleryImage[];

  public vCard: VCard;
  agente: any = {
    id: null,
    user_id: null,
    firstName: '',
    lastName1: '',
    lastName2: '',
    fullName: '',
    email: '',
    phone: '',
    marketStall: '',
    aboutMe: '',
    banner: '',
    photo: '',
    isWhatsApp: 0,
    tradeNameRealEstate: '',
    logoRealEstate: '',
    fbUrlRealEstate: '',
    streetRealEstate: '',
    noExtRealEstate: '',
    noIntRealEstate: '',
    suburbRealEstate: '',
    postalCodeRealEstate: '',
    stateRealEstate: '',
    provinceRealEstate: '',
    emailRealEstate: '',
    phone1RealEstate: '',
    phone2RealEstate: '',
    phone3RealEstate: '',
    isWhatsApp1RealEstate: 0,
    isWhatsApp2RealEstate: 0,
    isWhatsApp3RealEstate: 0,
    buttons: [],
    agentImages: [],
    aboutImages: [],
  };

  profileFacebook: string;
  facebook = false;
  public toggleMenu = true;
  url = environment.URL_AWS;
  ht: string = 'https://';
  subdomain: string = this.ht;
  urlShareCopy: string;

  constructor(private _landingService: LandingService,
    private _router: Router,
    private _route: ActivatedRoute,
    private modalService: NgbModal,
    private _currencyPipe: CurrencyPipe,
    private _coreConfigService: CoreConfigService,
    private titleService: Title) {
    console.log('ENTRO A DIGTITAL CARD CON CODE CONSTRUCTOR');
    var host = window.location.host
    this.subdomain += host.split('.')[0];

    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };

    const code = this._route.snapshot.paramMap.get('code');
    console.log('CODE', code);

    this.galleryOptions = [

      {
        image: false,
        thumbnails: false,
        width: "0",
        height: "0",
        previewZoom: true,
        previewBullets: true,
        previewKeyboardNavigation: true,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
      },
    ];


    this.galleryImages = [];
    this.galleryImagesAgent = [];

    this._landingService.getDigitalCard(code).then(
      (data: any) => {
        if (data.banner !== null && data.photo !== null && data.aboutMe !== null && data.aboutImages?.length > 0 && data.agentImages?.length > 0) {
          this.agente = data;

          let paramPhone: BasicPropertyParameters = { type: ['work', 'voice'] };
          let paramPhone2: BasicPropertyParameters = { type: ['voice'] };
          let paramps: BasicPropertyParameters = { type: 'work' };
          let paramAddress: BasicPropertyParameters = { type: ['work'], pref: 1 };
          let test: Address = {
            postalCode: this.agente.postalCodeRealEstate,
            street: this.agente.streetRealEstate + ', ' + this.agente.noExtRealEstate + ', ' + this.agente.noIntRealEstate + ', ' + this.agente.suburbRealEstate,
            locality: this.agente.provinceRealEstate,
            region: this.agente.stateRealEstate,
          };
          let address = {
            value: test,
            param: paramAddress
          };
          let phone = {
            value: this.agente.phone,
            param: paramPhone2
          };

          let phone2 = {
            value: this.agente.phone1RealEstate,
            param: paramPhone
          };
          this.vCard = {
            name: {
              firstNames: this.agente.firstName,
              lastNames: this.agente.lastName1 + ' ' + this.agente.lastName2,
            },
            organization: this.agente.tradeNameRealEstate,
            title: this.agente.marketStall,
            email: [{
              value: this.agente.emailRealEstate,
              param: paramps,
            }, this.agente.email],
            telephone: [phone, phone2],
            address: [
              address,
            ],
          };
          this.titleService.setTitle(this.agente.fullName);

          const link = document.querySelector("link[rel='icon']") as HTMLAnchorElement | null;
          if (link !== null) {
            link.href = this.url + this.agente.photo;
          }

          this.agente.aboutImages.forEach(e => {
            let imgG = {
              small: '',
              medium: '',
              big: this.url + e.path
            }

            this.galleryImages.push(imgG);
          });

          this.agente.agentImages.forEach(e => {
            let imgG = {
              small: '',
              medium: '',
              big: this.url + e.path
            }

            this.galleryImagesAgent.push(imgG);
          });

          setTimeout(() => {
            if (this.agente.fbUrlRealEstate) {
              if (this.agente.fbUrlRealEstate.includes("id")){
                let url = new URL(this.agente.fbUrlRealEstate);
                this.profileFacebook = url.searchParams.get("id");
              } else{
                this.profileFacebook = this.agente.fbUrlRealEstate.replace("https://www.facebook.com/", "");
                this.profileFacebook = this.profileFacebook.replace("/", "");
                if (this.profileFacebook.includes("?"))
                  this.profileFacebook = this.profileFacebook.split("?")[0]; 
              }
              console.log('profileFacebook', this.profileFacebook);

              let app = document.getElementById('frameFace');

              app.innerHTML = "<iframe src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F" + this.profileFacebook + "%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId' width='340' height='500' style='border:none;overflow:hidden;' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share' ></iframe>";
            }
          }, 500);


        } else {
          // data.banner !== null && data.photo !== null && data.aboutMe !== null && data.aboutImages?.length > 0 && data.agentImages?.length > 0
          console.log('NO HAY ERROR getDigitalCard CODE PERO FALTA ALGUNO DE ESTOS DATOS');
          console.log('data.banner', data.banner);
          console.log('data.photo', data.photo);
          console.log('data.aboutMe', data.aboutMe);
          console.log('data.aboutImages?.length', data.aboutImages?.length);
          console.log('data.agentImages?.length', data.agentImages?.length);
          // this._router.navigateByUrl('');
        }
      }, (error: any) => {
        console.log('ERROR getDigitalCard CODE', error);
        // this._router.navigateByUrl('');
      }
    );
  }

  showGallery(indexImg: number) {
    this.gallery.openPreview(indexImg);
  }

  showGalleryAgent(indexImg: number) {
    this.galleryAgent.openPreview(indexImg);
  }

  ngOnInit(): void {


  }

  onMouseEnterBtnDyn(element) {
    if (this.agente.colorAgent) {
      element.srcElement.style.cssText = 'background:' + this.agente.colorAgent.toString() + ' !important; color:white;';
    }
    else {
      element.srcElement.style.cssText = 'background:#125EAC !important; color:white;';
    }
    // element.srcElement.style.cssText = 'background-color:' + this.agente.primaryColor + ' !important;';

  }

  onMouseOutBtnDyn(element) {

    element.srcElement.style.cssText = 'background: rgb(241,241,241) !important; background: linear-gradient(162deg, rgba(241,241,241,1) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%) !important;font-weight: bolder; color:' + this.agente.colorAgent.toString();
  }

  modalOpenLink(modallink) {

    this.urlShareCopy = 'https://back.in-mo.app/agent/' + this.agente.id;

    this.modalService.open(modallink, {
      size: 'lg'
    });

  }

}
